import { render, staticRenderFns } from "./DCarousel.vue?vue&type=template&id=239ebe8f&scoped=true&"
import script from "./DCarousel.vue?vue&type=script&lang=js&"
export * from "./DCarousel.vue?vue&type=script&lang=js&"
import style0 from "./DCarousel.vue?vue&type=style&index=0&id=239ebe8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239ebe8f",
  null
  
)

export default component.exports